import { Col, Container, Row } from "react-bootstrap";
import { Editor } from "./components/editor/editor";
import { Header } from "../../components/header";
// import { useRouteMatch } from "react-router-dom";
// import { Routes } from "../../AppRoutes";

export const DocumentTemplatePage = () => {
  // const { id } = useRouteMatch().params as any;
  // const backLink = Routes.document.path + `?status=template`;

  return (
    <>
      <Header />
      <Container fluid>
        <Row>
          <Col sm={12} md={12} className="py-3">
            <Editor />
          </Col>
        </Row>
      </Container>
    </>
  );
};
